import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { CycleModule } from "@/store/modules/cycle.module";
import simplebar from "simplebar-vue";
let CycleReviewsSummary = /** @class */ (() => {
    let CycleReviewsSummary = class CycleReviewsSummary extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Reviews Status";
        }
        closeStatus() {
            this.$emit("close-popup");
        }
        created() { }
        destroyed() {
            CycleModule.ClearSummaryStatus();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], CycleReviewsSummary.prototype, "cycleSummary", void 0);
    CycleReviewsSummary = __decorate([
        Component({
            name: "CycleReviewsSummary",
            components: {
                simplebar,
            },
        })
    ], CycleReviewsSummary);
    return CycleReviewsSummary;
})();
export default CycleReviewsSummary;
